import { Box, Dialog } from "@mui/material";
import React, { useEffect, useState } from "react";

import inJailIcon from "../../assets/imgs/profile/injail.png";

import { useAppDispatch, useAppSelector } from "../../app/hooks";

import { ACTIVITY_LIMIT_DURATION } from "../../constants/const";
import { setRateLimitExceeded } from "../../reducers/auth.slice";

import useStyles from "./index.styles";

interface InJailPopupProps {
  openInJailPopup: boolean;
  setOpenInJailPopup: (open: boolean) => void;
}

const InJailPopup: React.FC<InJailPopupProps> = ({
  openInJailPopup,
  setOpenInJailPopup,
}) => {
  const { classes } = useStyles();
  const dispatch = useAppDispatch();

  const { activityTimestamps } = useAppSelector((state) => state.auth);

  const [, setRemainTime] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const remainTime =
        ACTIVITY_LIMIT_DURATION -
        (Math.floor(new Date().getTime() / 1000) -
          (activityTimestamps.at(0) || 0));
      if (remainTime >= 0) {
        setRemainTime(remainTime);
      } else {
        clearInterval(intervalId);
        dispatch(setRateLimitExceeded(false));
      }
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [activityTimestamps, dispatch]);

  return (
    <Dialog
      open={openInJailPopup}
      className={classes.body}
      onClose={() => setOpenInJailPopup(false)}
    >
      <Box className={classes.modalContent}>
        <Box className={classes.closeIconBody}></Box>

        <Box className={classes.contentBody}>
          <Box
            component="img"
            src={inJailIcon}
            className={classes.sirenIcon}
          ></Box>

          <Box className={classes.title}>Hold up, mobster!</Box>

          <Box className={classes.description}>
            Looks like you’ve been caught and sent to jail.
          </Box>

          <Box className={classes.countdown}>You’re on lockdown for a bit.</Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default InJailPopup;
